var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M32 5.23c0 .7-.13 1.36-.4 2-.25.65-.63 1.22-1.13 1.72L9.9 29.53 0 32l2.47-9.9L23.05 1.54c.5-.5 1.07-.88 1.72-1.14.64-.27 1.3-.4 2-.4s1.4.14 2.03.4c.63.3 1.2.67 1.66 1.14.47.47.85 1.03 1.13 1.66.2.64.4 1.32.4 2.03zM5.1 22.3c1.1.38 2.05.96 2.85 1.75.8.8 1.37 1.75 1.74 2.86L26.5 10 22 5.42 5.1 22.32zm-2.35 6.95l5.14-1.28c-.1-.48-.3-.93-.6-1.36-.25-.4-.5-.8-.87-1.1-.33-.3-.7-.6-1.14-.8-.44-.22-.9-.4-1.37-.5L2.7 29.3zM28 8.58l.75-.74c.24-.23.45-.47.64-.72.1-.26.3-.53.4-.83.1-.3.1-.7.1-1.1 0-.5-.1-.9-.27-1.3s-.4-.75-.7-1.05c-.3-.3-.64-.53-1.03-.7-.37-.17-.8-.26-1.24-.26-.4 0-.75.05-1.05.16-.3.1-.55.28-.8.47-.26.2-.5.4-.73.64l-.73.77 4.6 4.6z"})));
}

Edit.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Edit;

Edit.default = Edit;
